import React from 'react';
import { EditHandbookInput } from '../EditHandbookInput';
import { parseTextForLinks } from '../Handbook';
import { SectionRow, SectionRowItem } from './SectionRow';
import type { EdibleSectionProps, EditableSectionRowInfo, HandBookInfo } from './types';

type Props = EdibleSectionProps & {
  handbookInfo: HandBookInfo;
  editableSectionRowInfo: EditableSectionRowInfo[] | undefined;
  verticalDisplay?: boolean;
};

export function MedicalSection({
  editable,
  handbookInfo,
  editableSectionRowInfo,
  selectedField,
  verticalDisplay,
  onStartEdit,
  onCancelEdit,
  onSave,
}: Props) {
  return (
    <>
      {editableSectionRowInfo?.map(row => (
        <SectionRow verticalDisplay={verticalDisplay} label={row.label} info={row.info}>
          <SectionRowItem
            onEditClick={editable && onStartEdit ? () => onStartEdit(row.displayKey) : undefined}
          >
            {selectedField === row.displayKey ? (
              <EditHandbookInput
                handbookRowInfo={String(handbookInfo[row.displayKey])}
                onCancel={onCancelEdit}
                selectedField={row.displayKey}
                onSave={onSave ? value => onSave(row.editInputKey, value) : undefined}
              />
            ) : (
              parseTextForLinks(handbookInfo[row.displayKey])
            )}
          </SectionRowItem>
        </SectionRow>
      ))}
    </>
  );
}
